import {useAddNotification} from '@yandex-delivery/blocks'
import {setHandleError} from '@yandex-delivery/blocks/usetransition/useTransition'
import {ServerError} from '@yandex-delivery/core/utils/network'
import {get, getErrorMessage} from '@yandex-delivery/utils'
import {useEffect} from 'react'
import i18n from 'src/shared/i18n'

export const ErrorNotification = () => {
  const addNotification = useAddNotification()

  useEffect(() => {
    setHandleError((error?: unknown) => {
      if (error instanceof Error) {
        let errorMessage = getErrorMessage(error)

        if (error instanceof ServerError) {
          const yatraceId = get('headers.x-yatraceid', error)

          if (yatraceId) {
            errorMessage += '\n' + i18n.print('handle-error.copy-error-code', 'Скопировать код ошибки: ') + yatraceId
          }
        }

        addNotification(errorMessage, {
          type: 'error',
        })
      }
    })

    return () => {
      setHandleError(undefined)
    }
  }, [addNotification])

  return null
}
